module.exports = __webpack_public_path__ + "static/1_KING-83a072f6f7ef3b0a03a496c821c5803e.png";